import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const translationRequest = createAction(types.TRANSLATION_REQUEST);
export const translationSuccess = createAction(types.TRANSLATION_SUCCESS);
export const translationFailure = createAction(types.TRANSLATION_FAILURE);

export const translationUpdateRequest = createAction(
  types.TRANSLATION_UPDATE_REQUEST,
);
export const translationUpdateSuccess = createAction(
  types.TRANSLATION_UPDATE_SUCCESS,
);
export const translationUpdateFailure = createAction(
  types.TRANSLATION_UPDATE_FAILURE,
);

export const setTranslation = createAction(types.SET_TRANSLATION);
